import React from 'react'
import { Statistic } from "antd";

import './style.scss';

const CountdownAnd = Statistic.Countdown;

const Countdown = ({ value } : { value: string | undefined }) => {
  if (!value) return null;

  // D [days] H:mm:ss
  // D [days] HH[hours] mm[minutes] ss[seconds]
  return (
    <div className="v-countdown">
      <CountdownAnd value={value} format="D [days] H:mm:ss" />
    </div>
  )
}

export default Countdown;
